import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../config";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const UserRoleEditPage_v2 = () => {
  const { roleId } = useParams();
  const navigate = useNavigate();
  const [role, setRole] = useState({
    role_name: "",
    description: "",
  });
  const [permissions, setPermissions] = useState([]);
  const [availablePermissions, setAvailablePermissions] = useState([]);

  useEffect(() => {
    fetchRole();
    fetchPermissions();
    fetchRolePermissions();
  }, []);

  const fetchRole = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/admin/roles/${roleId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
        },
      });
      setRole(response.data);
    } catch (error) {
      console.error("Error fetching role:", error);
    }
  };
  const fetchRolePermissions = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/admin/roles/${roleId}/permissions`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
        },
      });
      setPermissions(response.data);
    } catch (error) {
      console.error("Error fetching role:", error);
    }
  };

  const fetchPermissions = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/admin/permissions`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
        },
      });
      setAvailablePermissions(response.data);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${BASE_URL}/admin/roles/${roleId}`,
        { ...role, permissions },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
          },
        }
      );
      Swal.fire("Success!", "Role updated successfully.", "success");
      navigate("/roles");
    } catch (error) {
      Swal.fire("Error!", "Failed to update role.", "error");
    }
  };

  const handlePermissionChange = (permission_id, isChecked) => {
    if (isChecked) {
      setPermissions([...permissions, permission_id]);
    } else {
      setPermissions(permissions.filter((id) => id !== permission_id));
    }
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-4">
      <h1 className="text-2xl font-bold mb-4">Edit Role</h1>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Role Name</label>
          <input
            type="text"
            value={role.role_name}
            onChange={(e) => setRole({ ...role, role_name: e.target.value })}
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Description</label>
          <input
            type="text"
            value={role.description}
            onChange={(e) => setRole({ ...role, description: e.target.value })}
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm"
          />
        </div>
        {/* <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Permissions</label>
          <div className="mt-2 space-y-2">
            {availablePermissions.map((permission) => (
              <div key={permission.permission_id} className="flex items-center">
                <input
                  type="checkbox"
                  checked={permissions.includes(permission.permission_id)}
                  onChange={(e) =>
                    handlePermissionChange(permission.permission_id, e.target.checked)
                  }
                  className="mr-2"
                />
                <span>{permission.permission_name}</span>
              </div>
            ))}
          </div>
        </div> */}
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded-md"
        >
          Update
        </button>
        <button
          type="button"
          onClick={() => navigate("/roles")}
          className="ml-2 bg-gray-500 text-white px-4 py-2 rounded-md"
        >
          Back
        </button>
      </form>
    </div>
  );
};

export default UserRoleEditPage_v2;
